<template>
	<layout>
		<pagetitle>Instellingen</pagetitle>
    <div class="row">
      <div class="col-md-12 p-0">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Home</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="logins-tab" data-toggle="tab" href="#logins" role="tab" aria-controls="logins" aria-selected="false">Logins</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="medewerkers-tab" data-toggle="tab" href="#medewerkers" role="tab" aria-controls="medewerkers" aria-selected="false">Medewerkers</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="rollen-tab" data-toggle="tab" href="#rollen" role="tab" aria-controls="rollen" aria-selected="false">Rollen</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="rechten-tab" data-toggle="tab" href="#rechten" role="tab" aria-controls="rechten" aria-selected="false">Rechten</a>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane bg-white p-3 fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
            Home
          </div>
          <div class="tab-pane bg-white p-3 fade" id="logins" role="tabpanel" aria-labelledby="logins-tab">
            <loginlog />
          </div>
          <div class="tab-pane bg-white p-3 fade" id="medewerkers" role="tabpanel" aria-labelledby="medewerkers-tab">
            <users></users>
          </div>

          <div class="tab-pane bg-white p-3 fade" id="rollen" role="tabpanel" aria-labelledby="rollen-tab">
            <roles />
          </div>

          <div class="tab-pane bg-white p-3 fade" id="rechten" role="tabpanel" aria-labelledby="rechten-tab">
            <permissions />
          </div>
        </div>
      </div>
    </div>
	</layout>
</template>

<script>
import layout from '../layout/layout.vue'
import loginlog from '../components/loginlog.vue'
import users from '../components/users.vue'
import roles from '../components/roles.vue'
import permissions from '../components/permissions.vue'

export default {

  	name: 'settings',

  	components:{
		  layout,
      loginlog,
      users,
      roles,
      permissions,
	  },
  	data () {
    	return {
        user: this.$store.state.user,
      }
  	}
}
</script>

<style lang="css" scoped>
</style>